module.exports = __webpack_public_path__ + "static/media/8OLA30.c0c8b713.jpg";